<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my-2 pa-2 fill-height sticky-card" elevation="0">
            <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-start">
                    <v-btn-back @click="$router.push({ name: 'booklet-templates' })" />
                    <v-text-field-filled
                        v-model="name"
                        label="Nom de la plaquette"
                        hide-details
                        class="px-1"
                        :disabled="readOnly"
                        density="compact"
                        @change="onNameChanged"
                    />
                </v-col>
                <v-col cols="4" class="d-flex align-left justify-start"> </v-col>
                <v-col cols="4" class="d-flex justify-end">
                    <v-select-filled
                        v-model="bundleType"
                        :items="bundleTypes"
                        hide-details="auto"
                        label="Régime"
                        :disabled="readOnly || idToDuplicate"
                        density="compact"
                    />
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        :disabled="disabledMutation"
                        @click="upsertBookletTemplate()"
                    >
                        {{ !idTemplate || idToDuplicate ? "Créer" : "Modifier" }}
                    </v-btn>
                </v-col>
                <!-- <v-col cols="2" class="d-flex align-center justify-end">

                </v-col> -->
            </v-row>
        </v-card>
        <div :style="'max-height:' + maxHeight + ';' + 'overflow:auto; margin-top: 1vh'">
            <BookletContent
                v-if="loaded"
                :bookletTemplateId="idTemplate"
                :booklet="content"
                :readonly_="readOnly"
                :bundleType="bundleType"
                @booklet-changed="onBookletChanged"
                :key="idTemplate"
            ></BookletContent>
            <ScopeManager
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :readonly="readOnly"
            />
        </div>
    </v-container>
</template>

<script lang="ts">
import { User } from "../../store/store";

import { Apollo } from "@/decorators";

import BookletContent from "../bookletTemplate/BookletContent.vue";
import ScopeManager from "../companyScope/ScopeManager.vue";
import BOOKLET_TEMPLATE from "../../graphql/booklet/BookletTemplate.gql";
import UPSERT_BOOKLET_TEMPLATE from "../../graphql/booklet/UpsertBookletTemplate.gql";
import ADD_PERSONALISED_FILE from "../../graphql/booklet/AddPersonalisedFile.gql";

import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

type BookletTemplateContent = {
    id: string;
    name: string;
    pages: any[];
    files: any[];
};

@Component({
    components: {
        BookletContent,
        ScopeManager,
    },
})
export class BookletTemplate extends Vue {
    @Prop({ default: null }) idTemplate: String;
    @Prop({ default: null }) idToDuplicate: String;

    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    loaded = false;

    readOnly = false;

    content: BookletTemplateContent = { id: "booklet", name: "Plaquette", pages: [], files: [] };
    contentToUpsert: BookletTemplateContent = null;

    toUpdate: boolean = false;

    upsertValid: boolean = false;

    step = "content";

    bundleTypes = [
        { title: "BNC", value: "BNC" },
        { title: "BIC IS - Régime simplifié", value: "RS_IS" },
        { title: "BIC IS - Régime normal", value: "RN_IS" },
        { title: "BIC IR - Régime simplifié", value: "RS_IR" },
        { title: "BIC IR - Régime normal", value: "RN_IR" },
        { title: "Revenus fonciers (SCI)", value: "RF" },
        { title: "BA réel normal", value: "RNA" },
        { title: "BA réel simplifié", value: "RSA" },
    ];

    // bobbeeId = getOSS360Company()

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isTemplateValid() {
        if (this.name && (this.contentToUpsert || this.idToDuplicate)) {
            return true;
        }
        return false;
    }

    get disabledMutation() {
        return !this.toUpdate || !this.isTemplateValid || this.readOnly || !this.scopeId;
    }

    beforeMount() {
        if (!this.idTemplate && !this.idToDuplicate) {
            this.loaded = true;
        }
    }

    isReadOnly(accountingCompany, accountingCompanyOwner) {
        // if modified also change isReadOnly used with other components using <Scope>
        if (this.idToDuplicate) {
            this.readOnly = false;
            return;
        }
        if (accountingCompany == null && accountingCompanyOwner.id !== this.accountingCompanyId) {
            this.readOnly = true;
        }
    }

    @Apollo({
        query: BOOKLET_TEMPLATE,
        variables() {
            return {
                id: this.idTemplate || this.idToDuplicate,
            };
        },
        skip() {
            return !this.idTemplate && !this.idToDuplicate;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.bookletTemplate) {
                    this.name = this.idToDuplicate ? "" : data.bookletTemplate.name;
                    if (data.bookletTemplate.content !== true) {
                        this.content = data.bookletTemplate.content;
                    } else {
                        debugger;
                    }
                    if (data.bookletTemplate.companyScope) {
                        this.scopeId = data.bookletTemplate.companyScope.id;
                        this.scopeName = data.bookletTemplate.companyScope.name;
                        this.bundleType = data.bookletTemplate.companyScope.taxSystems;
                        this.isReadOnly(
                            data.bookletTemplate.companyScope.accountingCompany,
                            data.bookletTemplate.companyScope.accountingCompanyOwner,
                        );
                    } else {
                        this.scopeId = "";
                        this.scopeName = "";
                        this.bundleType = "";
                    }
                    this.loaded = true;
                }
            }
        },
    })
    bookletTemplate: any = null;

    name: string = "";

    bundleType = "";

    async upsertBookletTemplate(file: { key: string } = null) {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_BOOKLET_TEMPLATE,
            variables: {
                id: this.idTemplate || "",
                name: this.name,
                createAccountingCompany: { connect: { id: this.accountingCompanyId } },
                updateAccountingCompany: { connect: { id: this.accountingCompanyId } },
                updateContent: this.idTemplate ? this.contentToUpsert : null,
                createContent: !this.idTemplate ? this.contentToUpsert : null,
                createScope: this.scopeId ? { connect: { id: this.scopeId } } : undefined,
                updateScope: this.scopeId ? { connect: { id: this.scopeId } } : undefined,
            },
        });

        if (result) {
            const id = result.data.upsertBookletTemplate.id;
            if (file) {
                const newFile = await this.$apollo.mutate({
                    mutation: ADD_PERSONALISED_FILE,
                    variables: {
                        file,
                        bookletTemplateId: id,
                    },
                });
                // if(newFile?.data?.addPersonalisedFile?.fileId) {
                // this.accountingForms.pages.push({
                //     cerfa: newFile.data.addPersonalisedFile.fileId,
                //     title: eventData.file.name.substring(0, eventData.file.name.lastIndexOf(".")),
                //     category: 'personalisedDocument',
                //     disabled: false
                // })
                // if(!this.booklet.files) { this.booklet.files = [] } // to remove when all past bookletTemplate will be adapted to this new format
                // this.booklet.files.push({
                //     id: newFile.data.addPersonalisedFile.fileId,
                //     name: eventData.file.name.substring(0, eventData.file.name.lastIndexOf(".")),
                //     parameters: []
                // })
            } else {
                debugger; // git-ignore
                console.error("Error addPersonFile");
            }
            debugger;

            if (!this.idTemplate) {
                this.$router.replace({ name: "booklet-template", params: { idTemplate: id } });
            } else if (file) {
                this.refresh();
            }
            // this.$router.push({ name: 'booklet-templates' })
            // this.content = { id: 'booklet', name: 'Plaquette', pages: [] }
        }
        this.toUpdate = false;
    }

    refresh() {
        if (this.$apollo.queries.bookletTemplate) {
            this.$apollo.queries.bookletTemplate.refetch();
        }
    }

    async onBookletChanged(data) {
        this.contentToUpsert = data.booklet;
        if (data.file) {
            await this.upsertBookletTemplate(data.file);
        } else {
            this.toUpdate = true;
        }
    }

    onNameChanged() {
        this.toUpdate = true;
    }

    get isRootUser() {
        return this.$store.state.user.isRoot;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (170 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }
}

export default toNative(BookletTemplate);
</script>

<style>
.sticky-card {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: white;
}
</style>
